import { render, staticRenderFns } from "./StartStore.vue?vue&type=template&id=32ca7c81&"
import script from "./StartStore.vue?vue&type=script&lang=js&"
export * from "./StartStore.vue?vue&type=script&lang=js&"
import style0 from "./StartStore.vue?vue&type=style&index=0&id=32ca7c81&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports